// import the required animation functions from the angular animations module
import { trigger, state, animate, transition, style, AnimationTriggerMetadata } from '@angular/animations';

export const navDropdownOpenClose =
trigger('navDropdownOpenClose', [
  state('true' , style({ opacity: 1, left: '0px' })),
  state('false', style({ opacity: 0, left: '30px' })),
  state('void', style({ opacity: 0, left: '30px' })),
  transition('void => 1', animate('0.5s ease-out')),
  transition('0 => 1', animate('0.5s ease-out')),
  transition('1 => 0', animate('0s'))

]);
